export const ENTITY_KINDS = [
    { value: 'person', label: 'Person', hint: 'A named human. Lore characters, celebrity visits, anyone with a story.' },
    { value: 'fansite', label: 'Fansite', hint: 'A Habbo community site. Bobba Homes, HabboWidgets, that sort of thing.' },
    { value: 'furni', label: 'Furni', hint: 'A piece of furniture or a rare.' },
    { value: 'room', label: 'Room', hint: 'A room in the hotel, public or player made.' },
    { value: 'npc', label: 'NPC', hint: 'A bot or hotel character. Frank himself, Bob the builder bot.' },
    { value: 'game', label: 'Game', hint: 'A game, in the hotel or on Frankly.' },
    { value: 'event', label: 'Event', hint: 'A one off happening. A campaign, a competition, a party.' },
    { value: 'place', label: 'Place', hint: 'Somewhere that is not a room. A hotel, a country, a website.' },
    { value: 'concept', label: 'Concept', hint: 'An idea or a mechanic. Trading, ranking up, the console.' },
    { value: 'other', label: 'Other', hint: 'Anything that does not fit the rest.' },
];

export const ENTITY_SUBTYPES = ['', 'user', 'staff', 'lore', 'celebrity', 'hotelstaff', 'publicroom', 'site', 'catalogue'];

export const ENTITY_STATUSES = [
    { value: 'active', label: 'Active', hint: 'Frank will use it.' },
    { value: 'draft', label: 'Draft', hint: 'Saved, but Frank ignores it until you make it active.' },
    { value: 'hidden', label: 'Hidden', hint: 'Kept on file and never shown.' },
];

export const LEXICON_KINDS = [
    'furni', 'range', 'class', 'skill', 'concept',
    'person', 'npc', 'place', 'fansite', 'event', 'lingo', 'game',
];

export const ALL_KINDS = [
    ...ENTITY_KINDS.map(kind => kind.value),
    ...LEXICON_KINDS,
].filter((value, index, list) => list.indexOf(value) === index).sort();

export const RECORD_TYPES = {
    entry: {
        key: 'entry',
        label: 'Entry',
        plural: 'Entries',
        tone: 'green',
        blurb: 'A card Frank shows when somebody asks about this thing. Written by hand, for anything nobody else on the site keeps a record of: lore characters, celebrity visits, public rooms, NPCs. Staff, members and ordinary Habbos do not need one, Frank looks those up live.',
    },
    keyword: {
        key: 'keyword',
        label: 'Keyword',
        plural: 'Keywords',
        tone: 'orange',
        blurb: 'A word that pins an answer. When it turns up in a question, Frank reaches straight for the entry you point it at instead of working the subject out himself. Use it when people ask for one thing in ten different ways.',
    },
    jargon: {
        key: 'jargon',
        label: 'Jargon',
        plural: 'Jargon',
        tone: 'blue',
        blurb: 'Habbo shorthand. When somebody types the term, Frank also searches the words you pair with it, so "hc" finds pages that only ever say "habbo club".',
    },
    term: {
        key: 'term',
        label: 'Term',
        plural: 'Terms',
        tone: 'yellow',
        blurb: 'A word Frank picked up from the pages he has read, and what kind of thing he thinks it is. Built automatically and rebuilt from Lab. Lock one to stop the next rebuild changing it, or switch it off if it is sending him the wrong way.',
    },
};

export const RECORD_ORDER = ['entry', 'keyword', 'jargon', 'term'];

export const kindLabel = (value) => {
    const found = ENTITY_KINDS.find(kind => kind.value === value);
    return found ? found.label : (value || 'unsorted');
};

export const EMPTY_ENTITY = {
    kind: 'person',
    subtype: '',
    name: '',
    headline: '',
    summary: '',
    body: '',
    imageUrl: '',
    linkUrl: '',
    linkLabel: '',
    status: 'active',
    priority: 1,
    protected: false,
    autoFacts: true,
    cues: '',
    aliases: [],
    facts: [],
    media: [],
};

export const entityFromDetail = (detail) => ({
    kind: detail.entity.kind,
    subtype: detail.entity.subtype || '',
    name: detail.entity.name,
    headline: detail.entity.headline || '',
    summary: detail.entity.summary || '',
    body: detail.entity.body || '',
    imageUrl: detail.entity.imageUrl || '',
    linkUrl: detail.entity.linkUrl || '',
    linkLabel: detail.entity.linkLabel || '',
    status: detail.entity.status,
    priority: detail.entity.priority,
    cues: (detail.entity.cues || []).join(', '),
    protected: detail.entity.protected,
    autoFacts: detail.entity.autoFacts,
    aliases: (detail.aliases || []).map(alias => ({ alias: alias.alias })),
    facts: (detail.facts || [])
        .filter(fact => fact.origin === 'manual')
        .map(fact => ({ label: fact.label, value: fact.value || '', url: fact.url || '' })),
    media: (detail.media || []).map(item => ({
        imageUrl: item.imageUrl,
        caption: item.caption || '',
        credit: item.credit || '',
    })),
});

export const splitCues = (value) => String(value || '')
    .split(',')
    .map(cue => cue.trim())
    .filter(Boolean);

export const entityPayload = (form) => ({
    ...form,
    subtype: form.subtype || null,
    cues: splitCues(form.cues),
    aliases: form.aliases.filter(alias => alias.alias?.trim()),
    facts: form.facts.filter(fact => fact.label?.trim()),
    media: form.media.filter(item => item.imageUrl?.trim()),
});
